import logo from '../../assets/footer-logo.png'
import telefone from '../../assets/telefone.png'
import email from '../../assets/email.png'


import { Contact, Container, Info, Epharma, Canais } from './styles';

export function Footer() {
    return (
        <Container>
            <Info>
                <Epharma>
                    <div>
                        <img src={logo} alt="ePharma Inovação, integração e cuidado em saúde" />
                    </div>

                    <Contact>
                        <p>
                            Al. Mamoré, 989 <br />
                            9° andar - Alphaville<br />
                            Barueri - SP
                        </p>
                    </Contact>
                </Epharma>  
                <Canais>
                    <h3>Canais de Atendimento</h3>
                    <div className='atendimento'>
                        <div>
                            <img src={telefone} />
                            <h4>11 4689 8686</h4>
                            <p>de segunda à sexta<br/>das 8h às 18h</p>
                        </div>
                        <div>
                            <img src={email} />
                            <h4> E-mail</h4>
                            <a href="mailto:atendimento@epharma.com.br">atendimento@epharma.com.br</a>
                        </div>
                    </div>
                </Canais>
            </Info>
        </Container>
    );
}